// import CountdownSale from './Countdown'

const BestSellerTitle = ({ data, type }: any) => {
   const _data = data?.[type];
   return (
        <>
            {_data?.map((heading: any, hid: number) => {
                const title = heading?.[`${type}_title`];
                const subTitle = heading?.[`${type}_subtitle`];
                if (title != '' || subTitle != '') {
                    return (
                        <div className={`relative mt-0 py-3 bg-white home-banner-swiper-colletion`} key={hid}>
                            <div className="flex flex-col w-full text-center bg-white px-4 sm:px-4 lg:px-0" >
                                {title != '' &&
                                    <h3 className="mt-0 text-xl font-bold tracking-tight text-center text-gray-900 heading sm:text-3xl">
                                        {title}
                                    </h3>
                                }
                                {subTitle != '' &&
                                    <h5 className="mt-2 text-xs font-light text-gray-500 sm:text-sm">
                                        {subTitle}
                                    </h5>
                                }
                            </div>
                        </div>
                    )
                }
            })}
        </>
   )
}

export default BestSellerTitle;